export default __webpack_public_path__ + "static/media/tilda_white.90a040bf.svg";